import { Layout } from 'antd';
import React, { Component } from 'react';
import HeaderBalken from './Header';
import Sidebar from './Sidebar';
import { Div } from './style';
const { Sider, Content } = Layout;

const ThemeLayout = (WrappedComponent) => {
  class LayoutComponent extends Component {
    constructor(props) {
      super(props);
      this.state = {
        collapsed: false,
        hide: true,
        customizerAction: false,
      };
      this.updateDimensions = this.updateDimensions.bind(this);
    }

    componentDidMount() {
      window.addEventListener('resize', this.updateDimensions);
      this.updateDimensions();
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.updateDimensions);
    }

    updateDimensions() {
      this.setState({
        collapsed: window.innerWidth <= 1200 && true,
      });
    }

    render() {
      const { collapsed, hide } = this.state;
      const topMenu = false;

      const toggleCollapsed = () => {
        this.setState({
          collapsed: !collapsed,
        });
      };

      const onShowHide = () => {
        this.setState({
          hide: !hide,
        });
      };

      const SideBarStyle = {
        marginTop: '3rem',
        padding: '1rem',
        overflowY: 'auto',
        height: '100vh',
        position: 'fixed',
        zIndex: 998,
      };

      return (
        <Div>
          <Layout className="layout">

            <HeaderBalken
              toggleCollapsed={toggleCollapsed}
              collapsed={collapsed}
              onShowHide={onShowHide}
              hide={hide}
              topMenu={topMenu}
            />
            <Layout>
              {!topMenu || window.innerWidth <= 991 ? (
                <Sider width={290} style={SideBarStyle} collapsed={collapsed} theme="light">
                  <Sidebar
                      // toggleCollapsed={toggleCollapsedMobile}
                  />
                </Sider>
              ) : // </ThemeProvider>
              null}
              <Layout className="atbd-main-layout">
                <Content>
                  <WrappedComponent {...this.props} />
                </Content>
              </Layout>
            </Layout>
          </Layout>
        </Div>
      );
    }
  }

  return LayoutComponent;
};
export default ThemeLayout;
